<template>
<!-- 
  Author: lan.h
  Date: 2021-10-26
  content: 支持机构
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>ORGANIZATION</p>
        <h1>支持机构</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" v-for="item in year_list" :key="item.id" @click="yearChange(item)">
          <p class="links-name" :class="active_year == item.id ? 'active' : ''">{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="org-content" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="list-content">
        <div class="info" v-for="item in org_list" :key="item.value">
          <div class="list-title">{{item.name}}</div>
          <div class="list-org">
            <div class="org-item" v-for="org, index in item.arr" :key="index">
              <img :src="org.logo_path | logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <links></links>
  </div>
</template>
<script>
import { getSupportOrganizationYear, getSupportOrganization } from '@/service/main.js'
import links from 'mcomponents/mLinks.vue'
export default {
  data() {
    return {
      loading: false,
      org_list: [],
      year_list: [],
      active_year: ''
    }
  },
  created() {
    this.getSupportOrganizationYear()
  },
  computed: {
    vb100_org_type() {
      return this.$store.state.list_meta.vb100_org_type
    }
  },
  components: {links},
  methods: {
    //获取年数据
    async getSupportOrganizationYear() {
      let res = await getSupportOrganizationYear({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.$set(this.$data, 'year_list', res.res)
        if(res.res.length > 0){
          this.active_year = res.res[0].id
          this.getSupportOrganization(res.res[0].id)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取机构数据
    async getSupportOrganization(awards_year_id) {
      this.loading = true
      let res = await getSupportOrganization({
        awards_year_id: awards_year_id
      }, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.org_list = []
        this.vb100_org_type.forEach(item =>{
          let arr = res.res.filter(e => e.type == item.value) || []
          if(arr.length > 0){
            let temp = {...item}
            temp.arr = arr
            this.org_list.push(temp)
          }
        })
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    yearChange(val) {
      this.active_year = val.id
      this.getSupportOrganization(val.id)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mcss/main/list.stylus';
.p_head 
  .p_links
    display flex
    flex-wrap wrap
    .links-item
      width 1.6rem
    .active
      color #D9BB9E
.org-content
  width 100%
  margin-top .5rem
  .info
    margin-bottom .35rem
  .list-org
    display flex
    flex-wrap wrap
    justify-content center
    .org-item
      width calc((100% - 0.7rem) / 3)
      margin 0.1rem
      height .8rem
      display flex 
      justify-content center 
      align-items center
      background #FFFFFF
      box-shadow 0px 2px 6px 0px rgba(121, 133, 143, 0.1)
      border-radius 4px
      img 
        max-width 100%
        max-height 100%
      &:nth-child(5n)
        margin-right 0
</style>